module.exports = __webpack_public_path__ + "static/img/member_list_1.381df66a.png";